import {AxiosProgressEvent, AxiosRequestConfig} from "axios"

import {api} from "../../Api"
import {AppInfo, ImportUploadRequest, R, SecretUpdateRequest} from "./ManagementType"

export const ManagementApi = {
    info: {
        key: () => ["info"],
        fn: () => api.get<R<AppInfo>>("/info")
            .then((response) => response.data.response),
    },
    changeSecret: {
        key: () => ["secret", "change"],
        fn: (request: SecretUpdateRequest) => api.post<R<string>>("/management/secret", request)
            .then((response) => response.data.response),
    },
    erase: {
        key: () => ["erase"],
        fn: () => api.delete<R<string>>("/management/erase")
            .then((response) => response.data.response),
    },
    free: {
        key: () => ["free"],
        fn: () => api.delete<R<string>>("/management/free")
            .then((response) => response.data.response),
    },
    export: {
        key: () => ["export"],
        fn: () => api.post("/management/export", {}, {responseType: "blob"})
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement("a")
                link.href = url
                link.setAttribute("download", "ivory.bak")
                document.body.appendChild(link)
                link.click()
                link.remove()
                window.URL.revokeObjectURL(url)
            }),
    },
    import: {
        key: () => ["import"],
        fn: async (request: ImportUploadRequest) => {
            const {file, setProgress} = request
            const formData = new FormData()
            formData.append("file", file)
            const config: AxiosRequestConfig = {
                headers: {"Content-Type": "multipart/form-data"},
                onUploadProgress: (progressEvent: AxiosProgressEvent) => setProgress && setProgress(progressEvent)
            }
            const response = await api.post<R<string>>("/management/import", formData, config)
            return response.data.response
        },
    }
}
